export interface SelectOptions {
  value: unknown;
  label: string;
}

export enum SelectType {
  MULTIPLE = 'multiple',
  SINGLE = 'single',
}
